import { render, staticRenderFns } from "./NotePadList.vue?vue&type=template&id=63abaafa&scoped=true"
import script from "./NotePadList.vue?vue&type=script&lang=js"
export * from "./NotePadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63abaafa",
  null
  
)

export default component.exports